import { doGet, doPut, doPost, doDelete } from './common';

const entity = 'goods';
const getList = (pagination = undefined, sort = undefined, keyword = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter !== '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }
  if (keyword) {
    if (filter !== '') filter += `&keyword=${keyword}`;
    else filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/${entity}${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getListCount = (keyword) => {
  let filter = '';
  if (keyword) {
    filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/${entity}/count${filter}`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}
const getListEnabled = () => {
  return doGet(`/api/${entity}`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsSpecListByGoodsId = (goods_id) => {
  return doGet(`/api/${entity}/${goods_id}/spec`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsSpec = (currency_id) => {
  return doGet(`/api/${entity}/spec/${currency_id}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}


const getGoodsListEnabledByCategoryId = (category_id) => {
  return doGet(`/api/${entity}?category_id=${category_id}`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getById = (id) => {
  return doGet(`/api/${entity}/${id}`)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (params) => {
  return doPost(`/api/${entity}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const getGoodsBySpecName = (goods_spec_name) => {
  return doGet(`/api/${entity}/spec/${goods_spec_name}`).then(res=> res.data)
    .catch(err => { })
    .finally(() => {

    });
}
const getGoodsByName = (goods_name) => {
  return doGet(`/api/${entity}/name/${goods_name}`).then(res=> res.data)
    .catch(err => { })
    .finally(() => {

    });
}

const insertSpec = (goods_id, params) => {
  return doPost(`/api/${entity}/${goods_id}/spec`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const insertSpecs = (goods_id, params) => {
  return doPost(`/api/${entity}/${goods_id}/specs`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updateSpecs = (goods_id, params) => {
  return doPut(`/api/${entity}/${goods_id}/specs`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updateSpec = (goods_id, goods_spec_id, params) => {
  return doPut(`/api/${entity}/${goods_id}/spec/${goods_spec_id}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const checkCanDelete = (goods_id) => {
  return doGet(`/api/${entity}/${goods_id}/used`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const checkCanDeleteSpec = (goods_id, goods_spec_id) => {
  return doGet(`/api/${entity}/${goods_id}/spec/${goods_spec_id}/used`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteSpec = (goods_id, goods_spec_id) => {
  return doDelete(`/api/${entity}/${goods_id}/spec/${goods_spec_id}`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const update = (id, params) => {
  return doPut(`/api/${entity}/${id}`, params).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}
const deleteById = (id) => {
  return doDelete(`/api/${entity}/${id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

//////////////////////////////////////////////////////////
// spec part
/////////////////////////////////////////////////////////
const getSpecPartList = (goods_id, goods_spec_id) => {
  return doGet(`/api/${entity}/${goods_id}/spec/${goods_spec_id}/part`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const insertSpecPart = (goods_id, goods_spec_id, params) => {
  return doPost(`/api/${entity}/${goods_id}/spec/${goods_spec_id}/part`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updateSpecPart = (goods_id, goods_spec_id, part_goods_spec_id, params) => {
  return doPut(`/api/${entity}/${goods_id}/spec/${goods_spec_id}/part/${part_goods_spec_id}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteSpecPart = (goods_id, goods_spec_id, part_goods_spec_id) => {
  return doDelete(`/api/${entity}/${goods_id}/spec/${goods_spec_id}/part/${part_goods_spec_id}`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const downloadTemplate = () => {
  return doGet(`/api/${entity}/template/download`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}

const downloadData = () => {
  return doGet(`/api/${entity}/download`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}

const downloadDataAll = () => {
  return doGet(`/api/${entity}/download/all`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}

export {
  getList,
  getListCount,
  getListEnabled,
  getGoodsListEnabledByCategoryId,
  getById,
  update,
  insert,
  getGoodsByName,
  getGoodsBySpecName,
  insertSpec,
  insertSpecs,
  updateSpecs,
  updateSpec,
  checkCanDelete,
  checkCanDeleteSpec,
  deleteSpec,
  deleteById,
  getGoodsSpecListByGoodsId,
  getGoodsSpec,
  insertSpecPart,
  updateSpecPart,
  deleteSpecPart,
  getSpecPartList,
  downloadTemplate,
  downloadData,
  downloadDataAll
}